import { storeToRefs } from 'pinia';
import { LeagueSize, SportType } from '@/interface/enum';
import { useToggleStore } from '@/store/toggleStore';

export function useJersey() {
    const { jerseyDisplayMatchExclusionRule } = storeToRefs(useToggleStore());

    function isJerseyVisible(eventCode: string, sportType: SportType, leagueSize: LeagueSize): boolean {
        const rule = jerseyDisplayMatchExclusionRule.value;

        if (rule && rule !== '-' && new RegExp(rule).test(eventCode)) {
            return false;
        }

        if (sportType === SportType.Soccer && leagueSize !== LeagueSize.Big) {
            return false;
        }

        return true;
    }

    return { isJerseyVisible };
}
